import Navbardesk from "../../navbar/components/Navbardesk";
import NavbarVertical from "../../navbar/components/NavbarVertical";

// Corregí el uso de children: se usa {children} directamente en lugar de <Children/>
// porque children es un nodo React, no un componente.
export default function LayoutDesk({children}) {
  const DEBUG = process.env.NODE_ENV === 'development';

  return (
    <div className='bg-neutral-900 min-h-screen w-full overflow-hidden'>
      {/* {DEBUG && <div className='text-center bg-blue-700'>desktop</div>} */}
      <Navbardesk/>
      <div className="flex pl-16">
        <NavbarVertical/>
        <div className="flex-1 overflow-hidden">
          {children}
        </div>
      </div>
    </div>

  )
}
